<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { mountedBase, BaseSetup } from "@/DataLoaderStatic";
import { getKennungValueDisplay, getKennungTitle } from "@/DataHelper";
const emit = defineEmits(["back"]);
const props = defineProps<{
  showMemo: boolean;
  zeitbereichUebergabe: APIZeitbereich;
  aic: number;
}>();

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_ReiseDaten_VG",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  pageParams.queryAIC = props.aic;
  pageParams.zeitbereich = props.zeitbereichUebergabe;

  await mountedBase(uiData, pageParams, false);
  uiData.showLoading = false;
  uiData.initialized = true;
});
</script>
<template>
  <v-card :loading="uiData.showLoading" v-if="uiData.initialized">
    <v-card-text class="pt-2 pb-0">
      <v-row>
        <v-col class="dvhCol" cols="12" xs="6">
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("MA_RELATION", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "MA_RELATION",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_REISEZWECK", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_REISEZWECK",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("BEGIN", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(uiData.data[0], "BEGIN", uiData.columns)
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_REISE_BEENDET", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_REISE_BEENDET",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_INLANDSREISE", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_INLANDSREISE",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_KATEGORIE", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_KATEGORIE",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_STATUSREISE", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_STATUSREISE",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_VORGAENGER_STATUS", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_VORGAENGER_STATUS",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="dvhCol pt-5">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("B_WAEHRUNG3", uiData.columns) }}:
              </span>
            </v-col>

            <v-col cols="5" class="dvhSpan pt-5">
              <span style="white-space: nowrap" class="dvhSpan">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "B_WAEHRUNG3",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("B_WAEHRUNG", uiData.columns) }}:
              </span>
            </v-col>

            <v-col cols="5" class="dvhSpan">
              <span style="white-space: nowrap" class="dvhSpan">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "B_WAEHRUNG",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col cols="3" class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("B_WAEHRUNG2", uiData.columns) }}:
              </span>
            </v-col>

            <v-col cols="5" class="dvhSpan">
              <span style="white-space: nowrap" class="dvhSpan">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "B_WAEHRUNG2",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
          <v-divider class="pt-5"></v-divider>
          <div></div>
          <v-row class="pt-2">
            <v-col cols="3" class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("ALL_ROUND_PRICE", uiData.columns) }}:
              </span>
            </v-col>

            <v-col cols="5" class="dvhSpan">
              <span style="white-space: nowrap" class="dvhSpan">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "ALL_ROUND_PRICE",
                  uiData.columns
                )
              }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <EditTextArea class="pt-10" kennung="MEMO" />
      <EditTextArea v-if="showMemo" class="pt-0" kennung="HINWEIS" />
    </v-card-text>

    <!-- <EditTextArea class="pt-0 pl-3 pr-5" kennung="HINWEIS" /> -->
  </v-card>
</template>
<style scoped>
.row {
  padding: 0px;
}
.dvhCol {
  padding-right: 0px;
  padding-left: 10px;
  padding-top: 0px;
  padding-bottom: 5px;
  align-items: left;
  text-align: left;
}
.dvhSpan {
  text-align: right;
  padding-top: 0px;
  padding-bottom: 5px;
}
</style>
